<template>
  <div class="control_dia">
    <el-dialog
      title="填写控件内容"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="858px"
      top="3%"
      @close="close"
    >
      <el-empty v-if="!fieldValueList.length" description="暂无可填写控件"></el-empty>
      <div class="dialog_content" v-loading="dialogLoading" v-else>
        <p style="color: #ff687b; margin-bottom: 15px">
          以下{{
            fieldValueList.length
          }}个控件内容未绑定参与方，请先填写完成再提交签署
        </p>
        <div
          class="control_content"
          v-for="(item, index) in fieldValueList"
          :key="index"
        >
          <div class="control_num">{{ index + 1 }}</div>
          <div class="con_ctop">
            <p>
              控件名称：<span style="color: #4c84ff">{{ item.fieldName }}</span>
            </p>
            <p>
              控件编码：<span style="color: #4c84ff">{{ item.fieldId }}</span>
            </p>
            <p>
              控件类型：<span style="color: #4c84ff">{{
                handleFieldType(item.fieldType)
              }}</span>
            </p>
          </div>
          <div class="con_center">
            <span style="margin-right: 8px"><span class="label-must" v-if="item.required">*</span>请填写：</span>
            <div style="flex: 1">
              <el-input
                v-if="item.fieldType === 'text_single_line'"
                v-model.trim="item.fieldValue"
                :placeholder="`请输入${item.fieldName}`"
              ></el-input>
              <el-input
                v-if="item.fieldType === 'text_multi_line'"
                v-model.trim="item.fieldValue"
                type="textarea"
                :placeholder="`请输入${item.fieldName}`"
              ></el-input>
              <el-input
                v-if="item.fieldType === 'number'"
                v-model="item.fieldValue"
                :placeholder="`请输入${item.fieldName}`"
                @input="item.fieldValue = item.fieldValue.replace(/[^0-9]/g, '')"
              ></el-input>
              <el-input
                v-if="item.fieldType === 'id_card'"
                v-model="item.fieldValue"
                :placeholder="`请输入${item.fieldName}`"
              ></el-input>
              <el-date-picker
                v-if="item.fieldType === 'fill_date'"
                v-model="item.fieldValue"
                type="date"
                value-format="yyyy年MM月dd日"
                placeholder="选择日期"
              >
            </el-date-picker>
              <el-radio-group
                v-model="item.fieldValue"
                v-if="item.fieldType === 'multi_radio'"
              >
                <el-radio :label="radio" v-for="(radio, index) in item.fieldMultiRadio.option" :key="index">{{radio}}</el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-if="item.fieldType === 'multi_checkbox'"
                v-model="item.fieldValue"
              >
                <el-checkbox v-for="(check,index) in item.fieldMultiCheckbox.option" :label="check" :key="index">{{
                  check
                }}</el-checkbox>
              </el-checkbox-group>
              <el-select
                v-if="item.fieldType === 'select_box'"
                v-model="item.fieldValue"
                placeholder="请选择"
              >
                <el-option
                  v-for="(select, index) in item.fieldSelectBox.option"
                  :key="index"
                  :label="select"
                  :value="select"
                >
                </el-option>
              </el-select>
              <!-- place-txt="提示：图片仅支持上传jpg/png/gif格式，建议尺寸：340-340px,最多上传3张。" -->
              <ElImgUploadGroupFaa
                v-if="item.fieldType === 'picture'"
                :propsImgUrl="item.customField1"
                @handleChange="handleUploadGroupChange($event,index)"
              />
              <p v-if="item.fieldType === 'table'" style="color: red">
                暂不支持填写表格控件，请前往法大大官网填写
              </p>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="fieldValueList.length">
        <el-button @click.native="close">取消</el-button>
        <el-button
          v-if="!dialogLoading"
          type="primary"
          :loading="btnLoading"
          @click.native="controlSuccess"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { _http } from "@/utils/request/evisaManagement";
import ElImgUploadGroupFaa from "@/components/global/components/elements/upload-group-element-faa";

export default {
  components: {
    ElImgUploadGroupFaa,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return {
          id: "",
        };
      },
    },
    docs: {
      type: Array,
      default: () => [],
    },
    fillFields: {
      type: Array,
      default: () => [],
    },
    dialogLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldValueList: [],
      btnLoading: false,
      fieldTypeOption: [
        { key: "text_single_line", name: "单行文本" },
        { key: "text_multi_line", name: "多行文本" },
        { key: "number", name: "数字控件" },
        { key: "id_card", name: "身份证号控件" },
        { key: "fill_date", name: "填写日期控件" },
        { key: "multi_radio", name: "单选框-多项控件" },
        { key: "multi_checkbox", name: "复选框-多项控件" },
        { key: "picture", name: "图片" },
        { key: "select_box", name: "下拉选择项" },
        { key: "table", name: "表格" },
      ],
    };
  },

  created() {
    this.getFadadaTemplateDetail();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleFieldType(key) {
      const currentObj = this.fieldTypeOption.find((item) => item.key === key);
      return currentObj ? currentObj.name : "--";
    },
    // 处理填写控件
    getFadadaTemplateDetail() {
      if (this.docs && this.docs.length) {
        this.fieldValueList = [];
        this.docs.forEach((item) => {
          if (item.docFields && item.docFields.length) {
            item.docFields.forEach((ele) => {
              let obj = {};
              obj.customField1 = "";
              obj.docId = item.docId;
              Object.keys(ele).forEach(key => {
                if (typeof ele[key] === 'object' && ele[key] !== null && 'required' in ele[key]) {
                  obj.required = ele[key].required;
                }
              });
              obj.fieldId = ele.fieldId;
              obj.fieldKey = ele.fieldKey;
              obj.fieldName = ele.fieldName;
              obj.fieldType = ele.fieldType;
              obj.fieldValue = "";
              if (ele.fieldMultiRadio) {
                obj.fieldMultiRadio = {
                  option: JSON.parse(ele.fieldMultiRadio.option)
                }
              }
              if (ele.fieldMultiCheckbox) {
                obj.fieldMultiCheckbox = {
                  option: JSON.parse(ele.fieldMultiCheckbox.option)
                }
                obj.fieldValue = [];
              }
              if (ele.fieldSelectBox) {
                obj.fieldSelectBox = {
                  option: ele.fieldSelectBox.option
                }
              }
              this.fieldValueList.push(obj);
            });
          }
        });
      }
      if (this.fillFields && this.fillFields.length) {
        this.fieldValueList.forEach((ele) => {
          this.fillFields.forEach((item) => {
            if (ele.docId == item.docId && ele.fieldId == item.fieldId) {
              ele.fieldValue = item.fieldValue;
              if(ele.fieldType === 'multi_radio'){
                let arr = JSON.parse(item.fieldValue);
                let trueIndex = arr.findIndex(value => value === true);
                ele.fieldValue = ele.fieldMultiRadio.option[trueIndex]
              }
              if(ele.fieldType === 'multi_checkbox'){
                let arr = JSON.parse(item.fieldValue);
                ele.fieldValue = arr.map((value, index) => value ? ele.fieldMultiCheckbox.option[index] : null).filter(value => value !== null);
              }
              if(ele.fieldType === 'picture'){
                ele.customField1 = item.customField1;
              }
            }
          });
        });
      }
    },
    controlSuccess() {
      if(this.fieldValueList.length){
        for (let i = 0; i < this.fieldValueList.length; i++) {
          if (this.fieldValueList[i].required && (!this.fieldValueList[i].fieldValue || (Array.isArray(this.fieldValueList[i].fieldValue) && this.fieldValueList[i].fieldValue.length === 0))) {
            console.log(this.fieldValueList[i],'this.fieldValueList[i].fieldValue');
            
            this.$message.error("请填写所有必填项");
            return;
          }
          if(this.fieldValueList[i].fieldType === 'id_card'){
            const idCardPattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (!idCardPattern.test(this.fieldValueList[i].fieldValue)) {
              this.$message.error("身份证格式不正确");
              return;
            }
          }
        }
      }
      this.btnLoading = true;
      let arr = []
      this.fieldValueList.forEach(item => {
        let obj = {
          docId: item.docId,
          fieldId: item.fieldId,
          fieldName: item.fieldName,
          fieldKey: item.fieldKey,
          fieldValue: item.fieldValue,
          customField1: item.customField1,
        }
        if(item.fieldType === 'table'){
          obj.fieldValue = []
        }
        if(item.fieldType === 'multi_radio'){
          item.fieldMultiRadio.option.forEach(ele => {
            obj.fieldValue = item.fieldMultiRadio.option.map(option => option === item.fieldValue);
            obj.fieldValue = JSON.stringify(obj.fieldValue)
          })
        }
        if(item.fieldType === 'multi_checkbox'){
          item.fieldMultiCheckbox.option.forEach(ele => {
            obj.fieldValue = item.fieldMultiCheckbox.option.map(option => item.fieldValue.includes(option));
            obj.fieldValue = JSON.stringify(obj.fieldValue)
          })
        }
        arr.push(obj)
      })
      _http
        .setFadadaFieldValue({
          taskId: this.row.id,
          fieldValueList: arr,
        })
        .then((res) => {
          this.$message.success(res.msg || "操作成功");
          this.close()
          this.$emit("setSuccess");
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleUploadGroupChange(obj,index) {
      if(obj.fileId){
        this.fieldValueList[index].fieldValue = obj.fileId;
        this.fieldValueList[index].customField1 = obj.imgUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control_dia {
  .red_text {
    color: #ff687b;
  }
  .blue_text {
    color: #0981ff;
  }
  .control_content {
    width: 800px;
    min-height: 92px;
    padding: 16px 0;
    background: #f5f6fa;
    border-radius: 4px;
    margin-bottom: 10px;
    position: relative;
  }
  .control_num {
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    font-size: 12px;
    color: #f5f6fa;
    width: 22px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #ffaf29;
    border-radius: 1px 8px 8px 1px;
    position: absolute;
    left: 0;
    top: 18px;
  }
  .con_ctop {
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .con_center {
    margin-top: 15px;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .dialog_content{
    max-height: 600px;
    overflow-y: scroll;
  }
  .label-must {
    color: #ff687b;
    margin-right: 4px;
  }
}
</style>
